import Splide from '@splidejs/splide'; // Import Splide

export default function registerSliderStore() {
  // SPLIDE slider store (for picture galleries)
  window.Alpine.store('sliderStore', {
    mainSlider: null,
    thumbnailSlider: null,

    initSliders() {
      const mountSliders = () => {
        // Check if we're in square mode
        const isSquareMode =
          document.body.classList.contains('square-mode') ||
          document.querySelector('.store-body.square-mode');

        console.log('Slider initialization - Square mode:', isSquareMode);

        const mainSliderOptions = {
          type: 'fade',
          rewind: true,
          pagination: true,
          arrows: true,
          cover: false, // Disable cover in all modes - our images are pre-processed
          lazyLoad: 'nearby',
        };

        // Only set heightRatio in landscape mode
        if (!isSquareMode) {
          mainSliderOptions.heightRatio = 0.6;
        }

        this.mainSlider = new Splide('#main-slider', mainSliderOptions).mount();

        const thumbnailOptions = {
          gap: 10,
          rewind: true,
          arrows: false,
          pagination: false,
          isNavigation: true,
        };

        if (isSquareMode) {
          // Square thumbnails
          thumbnailOptions.fixedWidth = 90;
          thumbnailOptions.fixedHeight = 90;
          thumbnailOptions.breakpoints = {
            600: {
              fixedWidth: 44,
              fixedHeight: 44,
            },
          };
        } else {
          // Landscape thumbnails (original)
          thumbnailOptions.fixedWidth = 133;
          thumbnailOptions.fixedHeight = 90;
          thumbnailOptions.breakpoints = {
            600: {
              fixedWidth: 60,
              fixedHeight: 44,
            },
          };
        }

        this.thumbnailSlider = new Splide(
          '#thumbnail-carousel',
          thumbnailOptions,
        ).mount();

        // Sync the main and thumbnail sliders
        this.mainSlider.sync(this.thumbnailSlider);
      };

      mountSliders();
    },
  });
}
